export default "__VITE_ASSET__3b0f9f31__"